import { useTranslation } from 'react-i18next';
import { IService } from '@clickersphere/core/entities/IService';
import { Button } from '../../Button';
import ImageUploadField from '../../Catalog/ImageUploadField';
import Hint from '../../Hint';
import { Input } from '../../Input';
import { useRegisterServiceFormController } from './useRegisterServiceFormController';

interface IRegisterServiceFormProps {
  service?: IService;
}

export default function RegisterServiceForm({
  service,
}: IRegisterServiceFormProps) {
  const { t } = useTranslation();
  const {
    isFetching,
    errors,
    register,
    control,
    handleSubmit,
    handleFormReset,
  } = useRegisterServiceFormController({ service });

  return (
    <form
      className="my-4 flex w-full flex-col items-center gap-4"
      onSubmit={handleSubmit}
      noValidate
    >
      <Input
        type="text"
        placeholder={t('catalog.form.fields.name.placeholderService')}
        {...register('name')}
        error={errors.name?.message}
        disabled={isFetching}
      />

      <Input
        type="text"
        placeholder={t('catalog.form.fields.description.placeholder')}
        {...register('description')}
        error={errors.description?.message}
        disabled={isFetching}
      />

      <div className="w-full space-y-1.5">
        <Input
          type="number"
          inputMode="decimal"
          placeholder={t('catalog.form.fields.price.placeholder')}
          step="0.01"
          min="0"
          {...register('price', { valueAsNumber: true })}
          error={errors.price?.message}
          disabled={isFetching}
        />
        <Hint>{t('catalog.form.fields.price.frozenHint')}</Hint>
      </div>

      <ImageUploadField
        name="imageUrl"
        control={control}
        label={t('catalog.form.fields.imageService')}
        disabled={isFetching}
        initialImageUrl={service?.imageUrl}
      />

      <section className="mt-4 flex w-full gap-4">
        <Button
          className="w-50"
          color="ghost"
          disabled={isFetching}
          onClick={() => handleFormReset()}
        >
          {t('catalog.form.actions.clear')}
        </Button>
        <Button type="submit" disabled={isFetching} isLoading={isFetching}>
          {t('catalog.form.actions.save')}
        </Button>
      </section>
    </form>
  );
}
